





















































import Vue from 'vue'
import store from '@/store'
export default Vue.extend({
  data() {
    return {
      isMobile: store.state.isMobile
    }
  },
  mounted() {
    store.setIsMobile()
    const observer = new IntersectionObserver(this.IOHandler, { rootMargin: '-20% 0px', threshold: 0 })
    Object.keys(this.$refs).forEach((key) => {
      const element = this.$refs[key] as HTMLElement
      observer.observe(element)
    })
  },
  methods: {
    IOHandler(entries: IntersectionObserverEntry[]) {
      entries.forEach((entry) => {
        const target = entry.target.querySelector('.block__headlineBar') as HTMLElement
        if (entry.isIntersecting) {
          target.classList.add('is-animated')
        } else {
          target.classList.remove('is-animated')
        }
      })
    }
  }
})
